import React, { FC } from 'react'
import './content.css'

// UTILITIES
import { flatten } from '@utils/string-helper'


interface Props extends React.HTMLAttributes<HTMLElement> {
    padding?: 'default' | 'none'
}

const ColumnContent: FC<Props> = (props) => {
    const { className: classProps, padding = 'default', ...sectionProps } = props
    const className = flatten('column-content', classProps)

    return <section className={className} data-padding={padding} {...sectionProps} />
}

export { ColumnContent }